import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
  Auth,
} from 'firebase/auth';
import {
  getFirestore,
  connectFirestoreEmulator,
  Firestore,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// In emulator mode the SDK still needs *some* projectId. Default to demo if absent.
if (!firebaseConfig.projectId) {
  firebaseConfig.projectId = 'demo-sprint-dashboard';
  firebaseConfig.apiKey = firebaseConfig.apiKey || 'demo-api-key';
}

export const app: FirebaseApp =
  getApps()[0] ?? initializeApp(firebaseConfig);

export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

if (useEmulator && typeof window !== 'undefined') {
  const authPort = Number(
    import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT ?? 9099,
  );
  const firestorePort = Number(
    import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT ?? 8080,
  );
const host = import.meta.env.VITE_FIREBASE_EMULATOR_HOST ?? '127.0.0.1';

  // Wrap in try/catch — connecting twice (HMR) throws.
  try {
   connectAuthEmulator(auth, `http://${host}:${authPort}`, { disableWarnings: true });

    // eslint-disable-next-line no-console
    console.info(`[firebase] Auth emulator @ :${authPort}`);
  } catch {
    /* already connected */
  }
  try {
    connectFirestoreEmulator(db, host, firestorePort);

    // eslint-disable-next-line no-console
    console.info(`[firebase] Firestore emulator @ :${firestorePort}`);
  } catch {
    /* already connected */
  }
}
